import { useState } from 'react'
import { apiUserLogin, apiUserRegister, apiUserDupCheck } from '../server/ServiceCall'
import { AuthState, parseLoginData, saveAuth } from '../store/auth'

interface Props {
  onLoggedIn: (a: AuthState) => void
}

type Mode = 'login' | 'register'

export default function Login({ onLoggedIn }: Props) {
  const [mode,    setMode]    = useState<Mode>('login')
  const [userId,  setUserId]  = useState('')
  const [pass,    setPass]    = useState('')
  const [pass2,   setPass2]   = useState('')
  const [name,    setName]    = useState('')
  const [busy,    setBusy]    = useState(false)
  const [msg,     setMsg]     = useState<string>('')

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true); setMsg('')
    try {
      const r = await apiUserLogin(userId.trim(), pass)
      if (r.resultCode !== '00') { setMsg(r.resultMessage || '로그인 실패'); return }
      const auth = parseLoginData(r.resultData)
      if (!auth) { setMsg('서버 응답 형식 오류'); return }
      saveAuth(auth)
      onLoggedIn(auth)
    } catch (err: any) {
      setMsg(err?.message || '네트워크 오류')
    } finally {
      setBusy(false)
    }
  }

  async function handleRegister(e: React.FormEvent) {
    e.preventDefault()
    if (pass !== pass2) { setMsg('비밀번호가 일치하지 않습니다.'); return }
    if (userId.length < 4) { setMsg('ID는 4자 이상이어야 합니다.'); return }
    if (pass.length < 4)   { setMsg('비밀번호는 4자 이상이어야 합니다.'); return }
    if (!name.trim())      { setMsg('표시 이름을 입력하세요.'); return }

    setBusy(true); setMsg('')
    try {
      const dup = await apiUserDupCheck(userId.trim())
      if (dup.resultCode !== '00') { setMsg(dup.resultMessage || '중복 확인 실패'); return }
      if (dup.resultData === 'Y')  { setMsg('이미 사용 중인 ID입니다.'); return }

      const r = await apiUserRegister(userId.trim(), pass, name.trim())
      if (r.resultCode !== '00') { setMsg(r.resultMessage || '회원가입 실패'); return }

      // 가입 성공 → 자동 로그인
      const lr = await apiUserLogin(userId.trim(), pass)
      if (lr.resultCode !== '00') { setMsg('가입은 됐으나 로그인 실패: ' + lr.resultMessage); return }
      const auth = parseLoginData(lr.resultData)
      if (!auth) { setMsg('서버 응답 형식 오류'); return }
      saveAuth(auth)
      onLoggedIn(auth)
    } catch (err: any) {
      setMsg(err?.message || '네트워크 오류')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>Web FM</h1>
        <p className="subtitle">가상 축구단 경영 시뮬레이션</p>

        <div className="tabs">
          <button
            className={mode === 'login' ? 'tab active' : 'tab'}
            onClick={() => { setMode('login'); setMsg('') }}
            disabled={busy}
          >로그인</button>
          <button
            className={mode === 'register' ? 'tab active' : 'tab'}
            onClick={() => { setMode('register'); setMsg('') }}
            disabled={busy}
          >회원가입</button>
        </div>

        {mode === 'login' ? (
          <form onSubmit={handleLogin} className="form">
            <input  type="text"     placeholder="ID"        value={userId} onChange={e => setUserId(e.target.value)} disabled={busy} autoFocus />
            <input  type="password" placeholder="비밀번호"   value={pass}   onChange={e => setPass(e.target.value)}   disabled={busy} />
            <button type="submit" disabled={busy}>로그인</button>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="form">
            <input  type="text"     placeholder="ID (4자 이상)"     value={userId} onChange={e => setUserId(e.target.value)} disabled={busy} autoFocus />
            <input  type="password" placeholder="비밀번호 (4자 이상)" value={pass}   onChange={e => setPass(e.target.value)}   disabled={busy} />
            <input  type="password" placeholder="비밀번호 확인"      value={pass2}  onChange={e => setPass2(e.target.value)}  disabled={busy} />
            <input  type="text"     placeholder="표시 이름"          value={name}   onChange={e => setName(e.target.value)}   disabled={busy} />
            <button type="submit" disabled={busy}>가입 후 시작</button>
          </form>
        )}

        {msg && <p className="msg">{msg}</p>}
        <p className="phase">Phase 0 — 인프라 골격</p>
      </div>
    </div>
  )
}
